(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var KEY = 'mud-collection-view';
    var root = document.documentElement;

    function read() {
      try { return localStorage.getItem(KEY) === 'columns' ? 'columns' : 'rows'; } catch (e) { return 'rows'; }
    }

    function sync() {
      var view = root.getAttribute('data-collection-view') || 'rows';
      document.querySelectorAll('[data-collection-view]').forEach(function (btn) {
        if (btn.tagName === 'BUTTON') { btn.setAttribute('aria-pressed', String(btn.getAttribute('data-collection-view') === view)); }
      });
    }

    function set(view) {
      root.setAttribute('data-collection-view', view);
      try { localStorage.setItem(KEY, view); } catch (e) {}
      sync();
    }

    root.setAttribute('data-collection-view', read());
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest('button[data-collection-view]');
      if (btn) { set(btn.getAttribute('data-collection-view')); }
    });
    document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
// Look for an element with class 'related-products'
var productRecommendationsSection = document.querySelector(".related-products");
if (productRecommendationsSection === null) { return; }
// Create request and submit it using Ajax
var request = new XMLHttpRequest();
request.open("GET", productRecommendationsSection.dataset.url);
request.onload = function() {
if (request.status >= 200 && request.status < 300) {
var container = document.createElement("div");
container.innerHTML = request.response;
productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
}
};
request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
loadProductRecommendationsIntoSection();
}
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
